var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfoundpage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 355,
    viewBox: "0 0 468 355",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.87 282.408L112.398 304.648",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M165.36 260.534H116.714L128.882 217.021C128.882 217.021 133.64 216.812 139.698 218.43C142.038 219.057 144.56 219.944 147.108 221.249C147.186 221.275 147.238 221.327 147.316 221.354C150.982 223.233 154.622 225.948 157.69 229.837C159.64 232.317 161.356 235.266 162.682 238.79C162.734 238.895 162.76 239.025 162.812 239.13C164.19 242.915 165.126 247.352 165.412 252.547C165.542 255.026 165.516 257.689 165.36 260.534Z",
    fill: "#ECF8FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M165.36 260.533H71.9941V270.583C71.9941 277.109 77.2721 282.408 83.7721 282.408H153.608C160.108 282.408 165.386 277.109 165.386 270.583V260.533H165.36Z",
    fill: "#ECF8FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.078 323.545C148.922 323.545 153.66 318.788 153.66 312.921C153.66 307.053 148.922 302.297 143.078 302.297C137.234 302.297 132.496 307.053 132.496 312.921C132.496 318.788 137.234 323.545 143.078 323.545Z",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.078 323.545C148.922 323.545 153.66 318.788 153.66 312.921C153.66 307.053 148.922 302.297 143.078 302.297C137.234 302.297 132.496 307.053 132.496 312.921C132.496 318.788 137.234 323.545 143.078 323.545Z",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M143.078 317.045C145.347 317.045 147.186 315.199 147.186 312.921C147.186 310.643 145.347 308.797 143.078 308.797C140.809 308.797 138.97 310.643 138.97 312.921C138.97 315.199 140.809 317.045 143.078 317.045Z",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.91 323.545C110.754 323.545 115.492 318.788 115.492 312.921C115.492 307.053 110.754 302.297 104.91 302.297C99.0659 302.297 94.3281 307.053 94.3281 312.921C94.3281 318.788 99.0659 323.545 104.91 323.545Z",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.91 323.545C110.754 323.545 115.492 318.788 115.492 312.921C115.492 307.053 110.754 302.297 104.91 302.297C99.0659 302.297 94.3281 307.053 94.3281 312.921C94.3281 318.788 99.0659 323.545 104.91 323.545Z",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.91 317.045C107.179 317.045 109.018 315.199 109.018 312.921C109.018 310.643 107.179 308.797 104.91 308.797C102.641 308.797 100.802 310.643 100.802 312.921C100.802 315.199 102.641 317.045 104.91 317.045Z",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M139.698 218.43C139.542 218.508 128.388 225.06 116.714 260.534L128.882 217.021C128.882 217.021 133.614 216.812 139.698 218.43Z",
    fill: "#DCF2FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M157.69 229.835C157.508 229.652 151.32 223.988 139.698 236.465C128.076 248.943 118.976 259.305 118.69 259.619L141.544 228.765L147.108 221.273C147.186 221.3 147.238 221.352 147.316 221.378C150.982 223.257 154.622 225.946 157.69 229.835Z",
    fill: "#DCF2FD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.386 252.546L165.36 252.676C165.36 252.676 157.508 243.958 118.69 259.62L162.812 239.129C164.164 242.914 165.1 247.351 165.386 252.546Z",
    fill: "#DCF2FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.316 221.354L116.714 260.534L162.682 238.79",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M165.36 270.791C165.36 270.791 121.16 254.373 71.9941 269.565V261.473H165.36V270.791Z",
    fill: "#DCF2FD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6943 234.168H79.6903C80.4183 234.168 81.0943 234.507 81.5363 235.082L135.564 304.672",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9941 260.533H165.36",
    stroke: "#D4E9F8",
    strokeWidth: 2.62562,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M341.744 323.234C355.472 307.912 365.768 291.049 372.372 273.142C381.186 249.128 382.98 224.669 384.722 200.994C385.112 195.747 385.398 190.422 385.58 185.149C385.632 183.844 387.608 183.896 387.556 185.228C387.374 190.527 387.088 195.878 386.698 201.15C384.956 224.956 383.136 249.571 374.218 273.847C367.562 291.989 357.11 309.06 343.226 324.565C342.316 325.557 340.86 324.226 341.744 323.234Z",
    fill: "#D7EDFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M384.15 215.27C388.726 211.459 392.756 207.074 396.188 202.193C396.942 201.097 398.554 202.271 397.8 203.341C394.264 208.353 390.104 212.895 385.424 216.811C384.41 217.62 383.136 216.106 384.15 215.27Z",
    fill: "#D7EDFA"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M378.56 249.231L396.526 230.019C397.41 229.053 398.866 230.411 397.982 231.376L380.016 250.588C379.106 251.554 377.65 250.197 378.56 249.231Z",
    fill: "#D7EDFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M371.41 276.326C377.546 271.21 384.332 266.851 391.508 263.379C392.704 262.805 393.562 264.606 392.366 265.18C385.528 268.495 378.872 272.724 372.684 277.892C371.67 278.702 370.396 277.162 371.41 276.326Z",
    fill: "#D7EDFA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M357.032 304.961C371.124 299.505 372.294 296.764 373.23 298.513C373.49 299.009 373.308 299.609 372.814 299.871C367.952 302.481 362.882 304.83 357.734 306.814C356.538 307.284 355.81 305.43 357.032 304.961Z",
    fill: "#D7EDFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M357.734 305.588C357.24 305.353 357.552 305.928 353.314 294.442C352.846 293.216 354.718 292.511 355.16 293.738L359.086 304.335C359.424 305.171 358.54 305.954 357.734 305.588Z",
    fill: "#D7EDFA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M368.68 284.287C367.406 283.66 368.888 282.408 368.03 276.9C367.016 270.557 364.39 269.304 366.028 268.416C366.522 268.155 367.12 268.338 367.38 268.808C369.798 273.324 370.76 278.44 370.136 283.504C370.006 284.183 369.278 284.574 368.68 284.287Z",
    fill: "#D7EDFA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M377.572 255.862C378.534 250.615 377.078 245.29 373.594 241.271C372.736 240.279 374.244 238.973 375.102 239.965C378.976 244.455 380.588 250.38 379.522 256.228C379.288 257.507 377.312 257.167 377.572 255.862Z",
    fill: "#D7EDFA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M383.785 218.117C383.395 217.935 383.785 218.483 378.585 209.242C377.935 208.094 379.677 207.102 380.301 208.25L385.085 216.734C385.553 217.569 384.643 218.535 383.785 218.117Z",
    fill: "#D7EDFA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M391.455 137.902C387.633 143.723 379.521 156.566 377.623 160.142C375.699 163.744 372.605 173.533 385.241 196.817C402.141 180.424 403.961 155.861 391.455 137.902Z",
    fill: "#ECF8FE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M391.248 209.425C393.51 193.894 404.456 182.357 419.276 178.023C418.522 194.233 406.874 206.684 391.248 209.425Z",
    fill: "#ECF8FE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M381.395 211.67C379.003 195.643 369.227 181.73 354.589 174.238C355.837 190.735 366.159 205.196 381.395 211.67Z",
    fill: "#ECF8FE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M387.479 240.984C392.939 221.041 409.033 207.859 428.325 204.57C424.061 224.774 408.435 239.757 387.479 240.984Z",
    fill: "#ECF8FE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M376.766 244.09C375.154 226.235 365.508 209.399 349.336 199.219C347.464 218.77 357.89 237.016 376.766 244.09Z",
    fill: "#ECF8FE"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M382.486 268.835C388.83 255.131 404.612 248.318 419.172 254.27C411.58 267.53 396.734 272.829 382.486 268.835Z",
    fill: "#ECF8FE"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M369.539 276.587C358.021 268.965 351.287 255.418 353.003 240.904C355.551 241.635 362.025 243.906 366.705 250.249C375.129 261.63 369.929 275.569 369.539 276.587Z",
    fill: "#ECF8FE"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M363.584 301.907C373.386 287.942 388.336 279.537 405.106 278.832C398.84 296.713 381.342 305.248 363.584 301.907Z",
    fill: "#ECF8FE"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M356.512 299.532C360.282 278.937 351.052 259.464 334.412 248.684C330.226 268.966 339.092 288.595 356.512 299.532Z",
    fill: "#ECF8FE"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7588 325.608C30.7588 325.608 200.435 322.919 246.195 323.18C291.955 323.441 437.061 325.608 437.061 325.608H30.7588Z",
    fill: "url(#paint0_linear)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M339.924 107.414L341.614 107.127C341.354 105.561 340.6 104.151 339.482 103.002C338.286 101.802 336.804 101.071 335.14 100.836L334.906 102.559C336.18 102.741 337.35 103.316 338.26 104.229C339.144 105.117 339.716 106.213 339.924 107.414Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M342.576 100.001C340.626 98.0429 338.13 96.79 335.4 96.3984L335.166 98.1212C337.532 98.4606 339.69 99.5308 341.38 101.227C342.992 102.846 344.032 104.882 344.422 107.127L346.112 106.84C345.67 104.229 344.448 101.88 342.576 100.001Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M168.506 182.616C168.506 182.616 164.45 183.503 163.046 185.461L169.416 177.447L168.506 182.616Z",
    fill: "#EC8B6C"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M183.04 313.314L182.832 317.778L191.1 320.022L192.998 321.301L180.882 323.103L176.904 319.996L176.748 313.262L183.04 313.314Z",
    fill: "#F79D75"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M191.1 320.022C191.1 320.022 196.69 321.823 197.314 322.763C197.99 323.755 196.924 324.799 195.338 324.982C190.268 325.582 180.102 325.791 177.528 325.478C174.59 325.112 176.826 318.561 176.826 318.561C177.034 319.161 177.372 319.735 177.71 320.231C178.36 321.171 179.192 321.745 180.31 322.006C181.298 322.267 182.312 322.319 183.326 322.293C184.756 322.267 186.186 322.137 187.616 321.928C188.604 321.797 189.618 321.719 190.528 321.301C190.84 321.145 191.256 320.91 191.282 320.544C191.308 320.336 191.23 320.153 191.1 320.022Z",
    fill: "#094E6B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M206.544 313.941L207.09 317.726L213.928 320.754L214.422 321.015C214.916 321.381 214.708 322.164 214.084 322.19L206.362 322.764C203.866 322.947 201.604 321.198 201.188 318.718L201.162 318.614L199.862 314.411L206.544 313.941Z",
    fill: "#F79D75"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M213.928 320.753C213.928 320.753 218.868 322.763 219.362 323.651C219.908 324.591 218.868 325.452 217.412 325.53C212.81 325.739 203.476 325.687 201.292 324.799C198.796 323.781 201.11 318.482 201.11 318.482C201.266 319.031 201.526 319.579 201.812 320.049C202.332 320.936 203.06 321.51 204.048 321.824C204.932 322.111 205.842 322.241 206.752 322.293C208.052 322.346 209.352 322.346 210.652 322.267C211.536 322.215 212.472 322.215 213.33 321.902C213.616 321.797 214.006 321.615 214.058 321.249C214.11 321.067 214.058 320.884 213.928 320.753Z",
    fill: "#094E6B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M205.972 194.389C205.972 194.389 208.884 210.521 197.028 248.527L186.42 314.907L175.968 314.933C175.968 314.933 175.656 303.996 175.916 294.964C176.098 288.934 175.864 262.205 180.648 246.856C179.738 238.895 179.322 228.793 177.164 219.448C170.742 209.477 174.278 203.134 175.552 199.27C178.308 191.126 185.848 192.64 205.972 194.389Z",
    fill: "#7B915E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M173.238 206.344C173.238 210.468 173.836 212.609 175.266 215.976C175.552 216.628 175.864 217.359 176.202 218.142C176.566 219.03 176.904 219.97 177.216 221.014C179.01 227.017 179.998 235.684 183.586 248.422C179.972 258.419 187.694 282.277 191.49 297.443C194.688 310.207 195.676 315.115 195.676 315.115H206.96C206.96 315.115 201.812 252.598 202.462 248.03C203.32 241.922 204.23 233.021 205.14 224.277C205.53 220.492 205.946 216.733 206.362 213.261C206.596 211.199 206.856 209.241 207.09 207.414C207.766 202.428 206.7 197.103 206.05 194.389C206.05 194.389 195.832 196.973 182.754 195.798C178.776 195.433 176.748 194.702 176.748 194.702C176.748 194.702 173.238 199.244 173.238 206.344Z",
    fill: "#9DA760"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M163.462 166.562V188.28L169.546 188.358L171.418 178.178L172.822 167.659L163.462 166.562Z",
    fill: "#F79D75"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M205.895 176.378C205.895 176.378 205.401 181.442 207.247 191.387C208.053 196.451 207.585 201.933 207.637 203.029C207.637 203.029 196.613 206.631 184.861 205.091C181.325 204.621 178.829 203.969 177.087 203.342C174.565 202.429 173.707 201.619 173.707 201.619C174.981 196.32 178.049 190.761 178.049 190.761C178.049 190.761 177.087 187.55 176.099 183.765C175.423 181.155 174.721 178.283 174.331 176.065C173.395 170.609 171.861 167.659 171.861 167.659L170.015 167.424L163.437 166.563C164.191 160.925 164.607 157.61 166.063 156.07C167.961 154.034 170.899 152.598 174.253 151.841C178.855 151.058 184.497 150.875 191.881 150.51C191.881 150.51 197.965 150.614 203.113 152.676C208.157 154.686 209.508 164.292 209.587 164.658H205.505C205.427 169.069 205.817 169.069 205.895 176.378Z",
    fill: "url(#paint1_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M199.498 177.97C192.686 178.779 175.552 192.614 177.112 203.342C174.59 202.428 173.732 201.619 173.732 201.619C175.006 196.32 178.074 190.76 178.074 190.76C178.074 190.76 177.112 187.55 176.124 183.765C177.346 182.12 178.152 181.05 178.152 181.05C178.152 181.05 191.802 176.821 195.156 176.952C198.51 177.109 202.774 177.735 205.894 176.352C205.894 176.378 206.284 177.161 199.498 177.97Z",
    fill: "#C2D9F1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M171.887 167.66C171.887 167.66 175.293 177.37 183.431 177.083C191.595 176.796 203.841 177.083 203.841 177.083C203.841 177.083 179.843 175.204 178.127 191.101L171.887 167.66Z",
    fill: "url(#paint2_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M193.31 190.683C191.516 194.468 187.902 196.843 183.95 193.397C177.58 187.89 172.614 178.806 171.964 174.394C171.288 169.748 171.106 170.061 171.236 168.338C171.34 166.929 171.626 164.058 174.642 162.204C174.642 162.204 176.956 161.186 177.242 161.134C180.7 160.273 182.728 161.682 183.612 162.544C184.496 163.405 192.816 176.926 194.298 183.191C194.818 185.566 194.402 188.386 193.31 190.683Z",
    fill: "#ADD1E9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M168.038 166.876C168.038 166.876 176.774 160.219 185.302 162.36",
    stroke: "#62CCEE",
    strokeWidth: 0.500028,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M168.352 167.19C168.352 167.19 177.088 160.534 185.616 162.674",
    stroke: "white",
    strokeWidth: 0.250014,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M168.766 168.677C168.766 168.677 177.606 161.969 186.004 164.109",
    stroke: "#62CCEE",
    strokeWidth: 0.496113,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M169.079 168.964C169.079 168.964 177.867 162.256 186.239 164.396",
    stroke: "white",
    strokeWidth: 0.248056,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M169.494 170.505C169.494 170.505 178.438 163.744 186.706 165.859",
    stroke: "#62CCEE",
    strokeWidth: 0.492197,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M169.834 170.766C169.834 170.766 178.674 164.032 186.916 166.172",
    stroke: "white",
    strokeWidth: 0.246099,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M170.248 172.305C170.248 172.305 179.296 165.492 187.434 167.606",
    stroke: "#62CCEE",
    strokeWidth: 0.488282,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M170.562 172.566C170.562 172.566 179.428 165.805 187.566 167.919",
    stroke: "white",
    strokeWidth: 0.244141,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M170.977 174.106C170.977 174.106 180.129 167.241 188.137 169.356",
    stroke: "#62CCEE",
    strokeWidth: 0.484366,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M171.315 174.342C171.315 174.342 180.233 167.53 188.241 169.67",
    stroke: "white",
    strokeWidth: 0.242183,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M171.704 175.933C171.704 175.933 180.96 169.016 188.864 171.13",
    stroke: "#62CCEE",
    strokeWidth: 0.480477,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M172.043 176.142C172.043 176.142 180.987 169.303 188.891 171.417",
    stroke: "white",
    strokeWidth: 0.240226,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M172.405 177.735C172.405 177.735 181.765 170.766 189.539 172.88",
    stroke: "#62CCEE",
    strokeWidth: 0.476562,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.771 177.944C172.771 177.944 181.767 171.079 189.541 173.167",
    stroke: "white",
    strokeWidth: 0.238268,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M173.134 179.562C173.134 179.562 182.598 172.54 190.242 174.655",
    stroke: "#62CCEE",
    strokeWidth: 0.472646,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M173.5 179.746C173.5 179.746 182.548 172.829 190.166 174.943",
    stroke: "white",
    strokeWidth: 0.23631,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M173.836 181.363C173.836 181.363 183.404 174.29 190.918 176.378",
    stroke: "#62CCEE",
    strokeWidth: 0.468731,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M174.201 181.52C174.201 181.52 183.275 174.577 190.789 176.665",
    stroke: "white",
    strokeWidth: 0.234352,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M174.538 183.191C174.538 183.191 184.21 176.065 191.594 178.153",
    stroke: "#62CCEE",
    strokeWidth: 0.464815,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M174.93 183.322C174.93 183.322 184.056 176.327 191.44 178.441",
    stroke: "white",
    strokeWidth: 0.232421,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M175.24 184.991C175.24 184.991 185.016 177.812 192.296 179.9",
    stroke: "#62CCEE",
    strokeWidth: 0.4609,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M175.658 185.122C175.658 185.122 184.836 178.101 192.09 180.189",
    stroke: "white",
    strokeWidth: 0.230463,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M175.941 186.792C175.941 186.792 185.821 179.562 192.971 181.65",
    stroke: "#62CCEE",
    strokeWidth: 0.456984,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M176.359 186.897C176.359 186.897 185.563 179.849 192.713 181.938",
    stroke: "white",
    strokeWidth: 0.228505,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M176.645 188.62C176.645 188.62 186.629 181.337 193.649 183.425",
    stroke: "#62CCEE",
    strokeWidth: 0.453069,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M177.088 188.697C177.088 188.697 186.344 181.597 193.364 183.685",
    stroke: "white",
    strokeWidth: 0.226548,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M177.346 190.42C177.346 190.42 187.434 183.085 194.324 185.147",
    stroke: "#62CCEE",
    strokeWidth: 0.44918,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M177.789 190.499C177.789 190.499 187.097 183.373 193.961 185.435",
    stroke: "white",
    strokeWidth: 0.22459,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M178.048 192.249C178.048 192.249 188.24 184.862 195 186.924",
    stroke: "#62CCEE",
    strokeWidth: 0.445264,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M178.518 192.301C178.518 192.301 187.852 185.123 194.612 187.211",
    stroke: "white",
    strokeWidth: 0.222632,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M178.75 194.049C178.75 194.049 189.046 186.61 195.676 188.672",
    stroke: "#62CCEE",
    strokeWidth: 0.441349,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M179.219 194.074C179.219 194.074 188.605 186.87 195.235 188.932",
    stroke: "white",
    strokeWidth: 0.220674,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M179.452 195.851C179.452 195.851 189.852 188.359 196.378 190.422",
    stroke: "#62CCEE",
    strokeWidth: 0.437433,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M179.946 195.876C179.946 195.876 189.384 188.646 195.884 190.708",
    stroke: "white",
    strokeWidth: 0.218717,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M180.153 197.677C180.153 197.677 190.657 190.133 197.053 192.195",
    stroke: "#62CCEE",
    strokeWidth: 0.433518,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M180.648 197.678C180.648 197.678 190.112 190.395 196.508 192.458",
    stroke: "white",
    strokeWidth: 0.216759,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M193.31 190.683C191.516 194.467 187.902 196.843 183.95 193.397C177.58 187.89 172.614 178.806 171.964 174.394C171.288 169.748 171.106 170.061 171.236 168.338C171.34 166.929 171.678 163.118 175.032 162.021C174.902 162.204 167.05 167.66 179.244 183.739C184.626 190.839 189.878 193.815 193.31 190.683Z",
    fill: "#3F7A8E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M169.806 192.092C169.806 192.092 167.232 192.744 166.374 192.849C165.776 192.927 163.904 190.995 163.748 190.447C163.228 188.672 163.618 183.843 163.618 183.843C163.618 183.843 177.632 181.598 186.914 178.936C187.72 178.179 188.24 176.978 189.02 176.665C189.228 176.508 190.918 175.908 191.308 175.83C191.386 175.803 191.828 175.725 191.932 175.777C191.984 175.803 192.244 175.96 192.296 176.091C192.348 176.195 192.374 176.325 192.4 176.404C192.426 176.56 192.4 176.717 192.296 176.848L191.906 177.291L192.582 177.5C192.582 177.5 193.076 177.813 193.284 178.466C193.544 179.197 193.57 181.05 193.57 181.05C193.57 181.05 192.686 181.677 192.426 181.755C191.438 182.068 188.448 181.781 188.448 181.781C188.058 181.755 187.642 181.833 187.304 182.042L169.806 192.092Z",
    fill: "#F79D75"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M209.586 164.657L211.276 181.78L211.094 183.399L205.946 177.76L205.426 162.49L209.586 164.657Z",
    fill: "#F79D75"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M205.946 177.762L186.134 186.428L183.638 186.141L182.39 186.506L181.402 187.629C181.272 187.759 181.324 188.046 181.688 188.072L182.156 187.968L184.184 187.394L182 188.125L179.218 188.464V189.325L180.778 190.97L182.494 192.014C182.494 192.014 184.21 192.144 184.782 192.014C185.666 191.805 187.85 190.239 187.85 190.239L206.726 185.54C207.272 185.41 207.792 185.201 208.286 184.94L211.068 183.4C211.068 183.4 212.264 180.241 208.91 178.44C208.26 178.075 205.946 177.762 205.946 177.762Z",
    fill: "#F79D75"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M176.046 162.49C176.046 162.49 173.758 163.925 175.162 168.389C176.566 172.853 180.128 176.037 182.234 177.003C184.964 178.23 190.476 175.176 189.462 172.226C188.448 169.276 185.536 163.116 182.13 161.811C178.698 160.48 176.046 162.49 176.046 162.49Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M205.426 162.49L208.91 178.439C208.104 177.969 207.558 177.787 206.7 177.708C206.362 177.682 205.894 177.76 205.894 177.76L205.426 162.49Z",
    fill: "#EC8B6C"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M196.586 134.065C195.702 137.981 191.178 142.966 182.26 148.37C178.178 149.831 176.384 145.838 176.072 142.758C175.916 141.191 192.322 118.012 191.828 117.359C196.196 119.839 198.458 125.869 196.586 134.065Z",
    fill: "url(#paint3_radial)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M199.316 132.863C198.172 132.002 197.366 131.271 196.82 130.592C194.792 128.086 196.144 126.468 195.312 123.675C194.48 120.778 193.05 118.768 192.556 118.115C192.452 117.985 192.4 117.906 192.374 117.906C192.374 117.932 192.426 117.985 192.504 118.089C193.102 119.029 195.442 122.97 192.556 123.675C178.256 127.042 178.178 138.24 178.178 138.24C178.178 138.24 182.624 144.583 182.338 151.501C181.35 151.814 180.388 152.127 179.946 152.284C179.946 152.284 186.472 163.482 193.7 162.882C200.824 162.281 196.066 150.926 196.066 150.926C196.066 150.926 191.698 150.457 189.566 150.143C189.514 149.778 189.462 149.413 189.384 148.995C189.384 148.917 189.358 148.838 189.358 148.734C189.332 148.577 189.306 148.447 189.306 148.29C188.89 145.262 190.762 144.557 192.738 144.166C193.934 143.931 195.182 143.826 195.988 143.409C197.834 142.417 196.794 136.753 196.872 135.5C196.924 134.194 200.304 134.221 199.316 132.863Z",
    fill: "#F79D75"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M195.52 138.58C195.52 138.58 194.714 140.042 192.946 138.998",
    stroke: "#CA835B",
    strokeWidth: 0.710705,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M183.768 143.199C183.768 143.199 185.068 149.177 189.462 150.012C189.436 149.934 189.332 148.785 189.332 148.681C189.306 148.524 189.28 148.394 189.28 148.237C188.864 145.209 190.736 144.504 192.712 144.113C192.348 144.191 186.524 144.478 183.768 143.199Z",
    fill: "#EC8B6C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M181.766 116.522C174.512 118.219 169.598 125.762 170.69 134.611C171.132 138.292 171.626 139.466 171.782 140.276C166.348 142.155 164.242 145.914 164.866 150.952C165.594 156.877 169.754 159.018 173.108 158.835C179.27 158.496 182.052 154.371 182.364 150.404C182.572 147.898 181.22 143.591 179.712 142.468C180.752 142.39 184.106 141.294 185.042 140.772C190.814 137.587 195.494 128.999 194.298 121.743C193.7 118.114 190.944 114.382 181.766 116.522Z",
    fill: "url(#paint4_radial)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M207.194 156.931C208.26 159.854 209.612 164.657 209.612 164.657H205.53C205.53 164.657 205.478 163.613 205.452 162.125C205.426 159.541 203.918 154.738 203.138 152.676C203.138 152.676 206.362 154.712 207.194 156.931Z",
    fill: "#D1E4F6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M185.562 169.982C185.094 170.451 184.418 170.895 183.586 171.13C182.364 171.522 180.83 171.469 179.218 170.451C177.84 169.564 175.578 165.048 178.516 162.829C182.312 160.558 185.172 164.631 185.172 164.631C185.172 164.631 187.642 167.867 185.562 169.982Z",
    fill: "#F79D75"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M179.972 168.234C179.972 168.234 180.856 168.26 181.636 167.686",
    stroke: "#DA8063",
    strokeWidth: 0.355366,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M182.884 167.006C182.884 167.006 183.742 166.771 184.314 165.988",
    stroke: "#DA8063",
    strokeWidth: 0.355366,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M183.716 169.773C184.103 169.773 184.418 169.457 184.418 169.068C184.418 168.679 184.103 168.363 183.716 168.363C183.328 168.363 183.014 168.679 183.014 169.068C183.014 169.457 183.328 169.773 183.716 169.773Z",
    stroke: "white",
    strokeWidth: 0.710705,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M183.586 171.156C182.364 171.548 180.83 171.496 179.218 170.478C177.84 169.59 175.578 165.074 178.516 162.855C178.516 162.855 177.736 170.06 183.586 171.156Z",
    fill: "#F38561"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M181.714 162.23C181.714 162.23 182.858 165.884 179.634 165.937C176.41 165.989 177.294 163.64 178.36 163.718C178.36 163.718 177.112 165.362 179.244 165.31C181.376 165.258 179.348 162.23 178.542 162.83C178.516 162.856 179.608 162.047 181.714 162.23Z",
    fill: "#DA8063"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M205.426 162.855C205.426 162.855 205.166 165.675 206.284 167.685C208.338 171.391 207.87 173.897 205.894 176.403C203.892 178.883 203.84 166.901 205.426 162.855Z",
    fill: "#F2F6FE"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M366.054 135.03V104.62H363.792V74.2098C363.792 68.3367 359.06 63.5859 353.21 63.5859H237.406C231.556 63.5859 226.824 68.3367 226.824 74.2098V314.957C226.824 320.831 231.556 325.581 237.406 325.581H353.236C359.086 325.581 363.818 320.831 363.818 314.957V199.374H366.08V147.063H363.818V135.03H366.054Z",
    fill: "#4B4C61"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M360.464 77.8398H230.698V297.314H360.464V77.8398Z",
    fill: "#F2F6FE"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M343.642 155.182H247.754V170.113H343.642V155.182Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M320.398 72.5399H273.728C272.792 72.5399 272.038 71.7829 272.038 70.8432C272.038 69.9035 272.792 69.1465 273.728 69.1465H320.398C321.334 69.1465 322.088 69.9035 322.088 70.8432C322.088 71.7568 321.334 72.5399 320.398 72.5399Z",
    fill: "#585870"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M338.286 114.723C345.93 114.723 352.118 108.51 352.118 100.836C352.118 93.1617 345.93 86.9492 338.286 86.9492C330.642 86.9492 324.454 93.1617 324.454 100.836C324.454 108.51 330.642 114.723 338.286 114.723Z",
    fill: "#57C5CC"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M343.226 102.636C342.706 102.114 342.082 102.114 341.562 102.636C341.172 103.028 340.782 103.419 340.392 103.811C340.288 103.915 340.21 103.941 340.08 103.863C339.82 103.732 339.56 103.602 339.326 103.471C338.182 102.767 337.246 101.827 336.414 100.809C335.998 100.287 335.634 99.7387 335.374 99.1384C335.322 99.0078 335.322 98.9295 335.426 98.8251C335.816 98.4597 336.206 98.0681 336.57 97.6766C337.116 97.1284 337.116 96.502 336.57 95.9538C336.258 95.6406 335.972 95.3534 335.66 95.0402C335.348 94.727 335.036 94.4137 334.724 94.1005C334.204 93.6045 333.554 93.6045 333.06 94.1005C332.67 94.492 332.28 94.8836 331.89 95.2751C331.526 95.6145 331.344 96.0582 331.292 96.5542C331.24 97.3634 331.422 98.1464 331.708 98.9034C332.28 100.47 333.164 101.853 334.23 103.106C335.66 104.829 337.376 106.186 339.404 107.152C340.314 107.596 341.25 107.935 342.264 107.987C342.966 108.039 343.564 107.857 344.058 107.309C344.396 106.943 344.76 106.604 345.124 106.238C345.644 105.716 345.644 105.064 345.124 104.542C344.474 103.889 343.85 103.263 343.226 102.636Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M274.951 179.875H249.887V205.038H274.951V179.875Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M308.412 179.875H283.348V205.038H308.412V179.875Z",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M342.498 179.875H317.434V205.038H342.498V179.875Z",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M274.951 214.174H249.887V239.337H274.951V214.174Z",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M308.412 214.174H283.348V239.337H308.412V214.174Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M342.498 214.174H317.434V239.337H342.498V214.174Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M274.951 248.475H249.887V273.638H274.951V248.475Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M308.412 248.475H283.348V273.638H308.412V248.475Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M342.498 248.475H317.434V273.638H342.498V248.475Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M295.568 320.284C300.278 320.284 304.096 316.45 304.096 311.722C304.096 306.993 300.278 303.16 295.568 303.16C290.858 303.16 287.04 306.993 287.04 311.722C287.04 316.45 290.858 320.284 295.568 320.284Z",
    fill: "#585870"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M325.65 186.375L336.05 196.816",
    stroke: "#F1F4FA",
    strokeWidth: 3.55355,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M336.05 186.375L325.65 196.816",
    stroke: "#F1F4FA",
    strokeWidth: 3.55355,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M302.146 133.229C300.3 130.802 297.856 129.705 297.154 127.33C296.582 127.461 296.036 127.591 295.49 127.696C293.098 128.139 286.52 128.296 284.076 128.244C278.928 142.47 285.402 148.421 288.678 150.066C294.554 153.041 299.52 150.771 301.08 149.961C304.122 148.369 304.98 144.741 305.136 143.984C306.15 138.737 302.744 134.012 302.146 133.229Z",
    fill: "#4D3655"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M305.527 155.469C305.527 155.469 296.635 150.457 296.817 138.711C296.843 136.336 295.907 128.714 295.907 128.714C295.907 128.714 284.883 131.559 279.163 117.307C279.163 117.307 278.513 120.674 279.449 126.886C279.657 128.322 276.719 130.88 276.927 132.159C276.953 132.368 279.657 132.603 279.657 132.838C279.709 134.9 279.995 138.868 280.879 139.729C281.607 140.434 282.933 140.773 284.337 140.904C285.793 141.034 287.925 141.452 288.653 141.478C289.667 144.297 288.055 146.594 288.055 146.594L286.365 147.717C286.365 147.717 281.425 161.342 292.293 161.264C300.795 161.134 303.187 161.838 305.527 155.469Z",
    fill: "#F9A97D"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M270.92 171.001L263.718 148.213L264.706 146.177C264.914 145.785 265.226 143.88 265.148 143.462C265.044 142.992 264.732 141.583 264.732 141.583C264.524 140.643 265.486 137.902 264.498 138.216C262.756 138.738 262.132 141.557 262.132 141.557L259.506 136.258C259.116 135.553 258.778 134.77 258.232 134.483C257.088 133.856 259.48 140.539 259.142 140.93C258.414 141.217 256.386 145.081 256.464 146.099C256.464 146.099 256.802 148.474 257.608 148.944C258.518 149.57 258.466 150.066 258.726 150.667C258.986 151.215 259.194 151.815 259.194 151.815L263.588 175.569C263.276 177.109 269.1 179.771 272.558 179.458L270.92 171.001Z",
    fill: "#F9A97D"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M310.83 217.412C311.428 218.352 311.714 219.474 311.662 220.597C311.532 223.624 311.324 230.907 311.74 241.897C312.364 258.576 310.362 305.797 311.168 309.138C311.246 309.425 311.298 309.738 311.35 310.051L312.312 320.205C312.624 323.39 310.206 326.183 307.034 326.314C303.914 326.444 301.288 323.99 301.236 320.858C301.132 316.76 301.054 311.618 301.184 309.79C303.004 282.8 292.708 239.26 293.462 225.765C294.19 212.844 304.252 207.075 310.83 217.412Z",
    fill: "#F4A884"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M301.184 309.764L301.938 325.478C301.938 325.478 308.334 323.285 312.234 325.321L311.298 309.32C312.26 309.895 312.312 313.105 314.626 325.53C314.86 326.783 315.042 330.49 312.026 330.96C311.792 330.986 311.558 331.09 311.324 331.116C310.232 331.273 308.308 331.403 305.656 331.508C302.77 331.638 302.276 331.56 301.418 331.168C300.118 330.568 300.222 327.88 300.196 327.305C300.092 325.843 300.014 312.635 301.184 309.764Z",
    fill: "#5C3E56"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M282.75 213.287C280.384 215.01 279.11 217.881 279.292 220.831C279.552 225.06 280.098 233.021 280.956 242.496C282.23 256.67 282.282 299.27 280.67 305.404C279.058 311.513 274.612 324.642 272.038 325.608C269.464 326.574 279.578 332.76 289.172 315.506C292.838 311.199 290.186 310.494 291.59 303.499C292.292 300.053 290.394 296.425 292.006 289.273C296.166 270.922 301.21 246.255 294.476 224.042C290.498 210.912 285.87 211.016 282.75 213.287Z",
    fill: "#F4A884"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M291.174 306.789C291.174 306.789 294.502 309.608 292.968 317.309C291.434 325.009 290.394 330.491 290.394 330.491H289.016L288.99 319.606C288.99 319.606 286.104 326.079 284.102 328.689C282.1 331.3 275.002 330.569 271.778 330.412C268.554 330.256 265.486 328.872 270.244 326.549L272.714 325.192C272.714 325.192 276.822 325.896 278.538 325.583C280.254 325.27 282.75 322.32 283.738 320.859C286.026 317.543 291.044 310.757 291.174 306.789Z",
    fill: "#5C3E56"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M276.718 155.285L271.284 182.458L278.018 187.026L285.48 164.108L276.718 155.285Z",
    fill: "#C2D5EE"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M314.913 201.436C314.913 201.436 322.869 216.706 311.637 268.416C311.637 268.416 294.685 270.27 281.737 268.756C281.737 268.756 270.921 222.762 277.837 201.201L314.913 201.436Z",
    fill: "#009FBA"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M285.715 147.821C285.715 147.821 280.385 149.649 277.863 153.642C275.341 157.662 278.487 163.849 275.393 171.001C272.299 178.127 277.161 180.685 277.863 182.904C278.539 185.149 280.203 194.128 277.863 201.202C277.863 201.202 277.057 204.674 282.127 205.248C287.223 205.822 296.843 207.519 305.527 205.248C314.211 202.977 314.575 198.592 314.575 198.592C314.575 198.592 311.429 186.323 311.871 177.109C312.313 167.895 315.745 156.462 312.443 151.084C309.115 145.707 292.527 145.864 292.527 145.864L285.715 147.821Z",
    fill: "#9BD4DD"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M290.005 145.864C288.705 146.178 287.041 146.83 284.701 148.24C283.895 149.127 282.543 153.565 283.791 159.699C284.805 164.737 288.133 166.59 288.783 166.12C289.433 165.65 300.821 159.412 302.173 152.782C303.005 148.71 304.903 145.003 303.317 143.985C301.705 143.019 297.129 144.089 290.005 145.864Z",
    fill: "#F9A97D"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M289.588 161.342L289.25 165.832C289.25 165.832 288.444 166.615 287.326 165.727C287.638 164.422 289.588 161.342 289.588 161.342Z",
    fill: "#EC8B6C"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M295.387 176.535L295.595 262.492C295.595 262.492 307.841 262.57 311.793 260.769L295.387 176.535Z",
    fill: "#016A81"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M314.574 169.355C314.574 169.355 313.69 177.108 309.712 186.897L314.574 169.355Z",
    fill: "#9BD4DD"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M304.33 144.559C304.33 144.559 316.108 150.014 317.148 152.598C318.292 155.496 319.41 161.317 317.486 171.079C315.588 180.842 313.508 187.237 314.6 198.644C315.692 210.025 321.984 229.994 320.216 259.568C320.216 259.568 306.358 262.231 296.998 261.03C296.998 261.03 295.646 234.849 295.646 229.263C295.646 223.677 294.944 180.972 295.88 174.394C296.79 167.79 304.642 152.363 304.33 144.559Z",
    fill: "url(#paint5_linear)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M300.248 142.939C300.248 142.939 300.927 149.648 300.248 154.895",
    stroke: "white",
    strokeWidth: 0.854663,
    strokeMiterlimit: 10
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M288.704 165.389C288.704 165.389 283.973 189.612 286.209 201.437",
    stroke: "black",
    strokeWidth: 1.28197,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M287.196 206.709C288.991 206.709 290.446 205.248 290.446 203.446C290.446 201.644 288.991 200.184 287.196 200.184C285.401 200.184 283.946 201.644 283.946 203.446C283.946 205.248 285.401 206.709 287.196 206.709Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M284.805 153.59C285.013 151.789 286.313 146.438 287.275 144.715",
    stroke: "white",
    strokeWidth: 0.854663,
    strokeMiterlimit: 10
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M300.248 155.286C299.026 161.185 295.048 165.205 291.226 165.388C283.296 165.753 283.582 160.402 284.7 153.902",
    stroke: "black",
    strokeWidth: 1.28197,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M299.677 143.592C300.366 143.592 300.925 143.031 300.925 142.339C300.925 141.647 300.366 141.086 299.677 141.086C298.987 141.086 298.429 141.647 298.429 142.339C298.429 143.031 298.987 143.592 299.677 143.592Z",
    fill: "#524C4E"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M284.31 200.184L283.972 262.726L280.254 262.126L284.31 200.184Z",
    fill: "#016A81"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M278.383 185.199L265.383 150.926L258.675 153.145C258.675 153.145 263.771 183.972 269.543 192.325C270.687 193.996 274.925 196.267 276.927 195.64C278.565 195.144 278.383 185.199 278.383 185.199Z",
    fill: "url(#paint6_linear)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M282.802 223.651C282.802 236.441 283.114 261.631 283.114 261.631C279.474 261.605 277.576 260.691 277.576 260.691C277.576 260.691 277.212 260.091 275.21 243.594C275.158 243.15 275.106 242.706 275.054 242.236C274.586 238.373 274.326 234.719 274.222 231.247C273.494 209.138 278.85 194.755 278.382 189.926C277.81 184.34 274.95 180.346 274.378 175.7C273.806 171.054 275.808 169.957 276.224 166.642C276.64 163.327 275.652 157.115 277.316 153.512C278.512 150.902 284.518 148.344 284.7 148.266C281.19 151.816 286.156 169.435 286.364 171.993C286.572 174.525 282.802 215.429 282.802 223.651Z",
    fill: "url(#paint7_linear)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M307.137 150.926L307.709 159.227L303.887 158.731L307.189 161.184L295.775 173.87L303.419 150.926H307.137Z",
    fill: "#E1EEF9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M311.272 133.464C309.426 131.037 306.982 129.94 306.28 127.565C306.176 127.2 306.046 126.782 305.916 126.312C305.162 123.78 304.018 119.865 303.732 119.238C301.47 114.67 297.336 113.443 294.996 112.843C291.746 111.982 280.67 110.52 278.2 115.636C278.2 115.662 277.862 116.55 277.888 117.385C277.94 118.56 277.94 120.021 278.85 121.849C278.876 121.588 279.292 119.839 279.292 119.839C280.826 125.033 285.896 129.679 289.952 131.533C290.55 131.794 291.252 132.029 292.084 132.238C289.25 143.775 294.866 148.813 297.83 150.327C303.706 153.303 308.672 151.032 310.232 150.222C313.274 148.63 314.132 145.002 314.288 144.245C315.302 138.946 311.87 134.247 311.272 133.464Z",
    fill: "url(#paint8_radial)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M284.701 148.238L281.243 150.092L279.371 155.417L283.245 156.2L279.267 158.262L286.209 174.446C286.209 174.446 286.339 172.566 286.339 170.817C284.935 164.553 282.153 152.885 284.701 148.238Z",
    fill: "#E9F7FE"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M265.383 150.926L258.389 153.249L258.961 156.355L266.917 153.98L265.383 150.926Z",
    fill: "#D1E4F6"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M277.837 231.219V242.417L275.211 243.565C275.159 243.122 275.107 242.678 275.055 242.208C274.587 238.345 274.327 234.69 274.223 231.219H277.837Z",
    fill: "#E1EEF9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M284.18 135.84C284.18 135.84 283.374 137.302 281.606 136.257",
    stroke: "#CA835B",
    strokeWidth: 0.710705,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M264.031 142.651L258.831 145.183C258.623 145.288 258.337 145.21 258.233 144.975C258.129 144.766 258.207 144.479 258.441 144.374L263.641 141.842C263.849 141.738 264.135 141.816 264.239 142.051C264.343 142.286 264.265 142.547 264.031 142.651Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M257.837 132.629L254.797 134.113L259.709 144.254L262.748 142.77L257.837 132.629Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M261.875 142.185L262.062 142.094L257.969 133.643L257.782 133.734L261.875 142.185Z",
    fill: "#626972"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M257.389 131.692L254.35 133.176L254.804 134.115L257.844 132.631L257.389 131.692Z",
    fill: "#626972"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M257.765 134.243L256.923 134.654L256.98 134.772L257.821 134.361L257.765 134.243Z",
    fill: "#88909C"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M258.205 135.157L257.363 135.568L257.42 135.686L258.262 135.275L258.205 135.157Z",
    fill: "#88909C"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M258.645 136.071L257.804 136.482L257.861 136.6L258.702 136.189L258.645 136.071Z",
    fill: "#88909C"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M259.086 136.988L258.244 137.398L258.301 137.516L259.143 137.105L259.086 136.988Z",
    fill: "#88909C"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M259.526 137.902L258.685 138.312L258.741 138.43L259.583 138.019L259.526 137.902Z",
    fill: "#88909C"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M259.978 138.841L259.137 139.252L259.194 139.369L260.035 138.958L259.978 138.841Z",
    fill: "#88909C"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M260.419 139.755L259.577 140.166L259.634 140.283L260.476 139.872L260.419 139.755Z",
    fill: "#88909C"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M260.859 140.671L260.018 141.082L260.074 141.199L260.916 140.788L260.859 140.671Z",
    fill: "#88909C"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M261.324 141.573L260.482 141.984L260.539 142.102L261.381 141.691L261.324 141.573Z",
    fill: "#88909C"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M255.944 132.393L255.814 132.471L252.486 125.319L252.512 125.293L255.944 132.393Z",
    fill: "#626972"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M258.44 141.504C258.44 141.504 258.44 141.791 258.778 142.392C259.142 143.07 259.87 144.114 260.286 145.002C260.546 145.576 260.364 146.02 260.286 146.229C259.792 147.168 258.024 147.978 257.66 147.978C257.192 147.978 256.75 147.534 256.516 147.325C256.282 147.116 255.996 146.933 255.736 146.672C255.554 146.15 255.112 144.976 255.58 144.819C256.022 144.689 255.814 143.775 256.048 143.436C256.412 142.966 256.464 142.835 257.218 142.705C257.972 142.574 257.894 141.374 258.44 141.504Z",
    fill: "#EC8B6C"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M309.712 164.893C309.712 164.893 312.052 181.729 312.286 188.986C312.572 198.304 308.542 221.771 308.542 221.771L316.602 188.986L309.712 164.893Z",
    fill: "#C2D9F1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M314.184 195.016C311.688 202.272 309.348 221.719 308.386 226.417C306.826 229.811 304.694 231.403 303.706 233.256C302.744 235.11 302.484 236.128 303.472 236.206C304.486 236.258 305.214 235.815 305.214 235.815C305.214 235.815 305.37 237.877 305.344 238.477C305.318 239.077 306.202 239.391 307.372 240.043C308.568 240.696 310.648 240.148 312.702 239.808C314.756 239.469 314.73 239.286 315.25 238.921C315.666 238.608 315.744 237.955 315.484 234.509C315.224 231.09 314.652 230.281 314.652 230.281C314.366 228.401 314.548 227.723 314.548 227.723C314.548 227.723 320.112 209.555 321.75 203.656L314.184 195.016Z",
    fill: "#FBAD83"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M302.251 231.585L316.577 231.271V244.427L310.103 247.194L302.225 245.55L302.251 231.585Z",
    fill: "#F2F6FE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M322.764 168.702C322.166 162.646 320.892 158.052 319.748 155.572C318.37 152.649 315.614 150.926 314.054 150.926C307.736 150.952 308.594 156.668 308.854 161.054C309.062 164.578 311.038 169.459 311.714 176.141C311.974 178.621 314.808 188.384 314.808 188.384L307.736 224.693L316.68 226.99C316.68 226.99 324.792 200.13 324.818 188.149C324.792 188.149 323.96 180.788 322.764 168.702Z",
    fill: "url(#paint9_linear)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M308.075 221.928L317.435 224.355L316.447 228.036L307.425 226.235L308.075 221.928Z",
    fill: "#F2F6FE"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M288.054 146.517C290.706 144.925 290.706 141.531 290.706 141.531C288.184 141.166 285.402 140.957 285.402 140.957C285.402 140.957 287.456 141.871 287.924 142.34C288.782 143.176 289.25 143.985 288.054 146.517Z",
    fill: "#EC8B6C"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M287.405 146.045C288.037 146.045 288.549 145.531 288.549 144.897C288.549 144.262 288.037 143.748 287.405 143.748C286.773 143.748 286.261 144.262 286.261 144.897C286.261 145.531 286.773 146.045 287.405 146.045Z",
    fill: "#524C4E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 30.7572,
    y1: 324.39,
    x2: 437.061,
    y2: 324.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7.6294e-7,
    stopColor: "#DCF2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9F7FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 163.474,
    y1: 177.997,
    x2: 209.598,
    y2: 177.997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7.68094e-7,
    stopColor: "#B7DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 176.721,
    y1: 179.396,
    x2: 208.689,
    y2: 179.396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 7.68094e-7,
    stopColor: "#B7DEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(175.298 132.924) rotate(2.66488) scale(63.7173 63.9685)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0423428,
    stopColor: "#794C76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#452232"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(195.561 124.941) rotate(-9.27218) scale(30.4703 30.5847)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.38175e-7,
    stopColor: "#986C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A3F4B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 296.564,
    y1: 283.948,
    x2: 315.368,
    y2: 174.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000110059,
    stopColor: "#D9EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539,
    stopColor: "#F3F3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6699,
    stopColor: "#EFF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8027,
    stopColor: "#E3EAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9359,
    stopColor: "#CFE0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2D9F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 272.157,
    y1: 184.817,
    x2: 254.922,
    y2: 138.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 290.53,
    y1: 230.031,
    x2: 251.061,
    y2: 123.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2D9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3F3F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(278.319 112.917) scale(31.6259 31.7511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA67F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00811182,
    stopColor: "#DAA57E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2801,
    stopColor: "#B47A6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    stopColor: "#9D6A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#7F575B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8576,
    stopColor: "#6D4B56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#674754"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 316.584,
    y1: 260.998,
    x2: 316.12,
    y2: 182.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00000110059,
    stopColor: "#D9EBF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1285,
    stopColor: "#F3F3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4263,
    stopColor: "#EFF1F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7277,
    stopColor: "#E3EDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1E6F7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfoundpage);
export default __webpack_public_path__ + "static/media/notfoundpage.c385cd22ffefb307d161a0930c174010.svg";
export { ForwardRef as ReactComponent };